export class ResponseFindConditionViewModel {
    userName = "";
    responseReason = "";
}
